import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const Contact = () => {
  return (
    <section id="contact" className="py-5 bg-dark text-white">
      <div className="container text-center">
        <h2 className="fw-bold mb-4">FALE CONOSCO</h2>
        <p className="mb-4 fs-5">
          Entre em contato pelo WhatsApp e descubra como podemos ajudar a impulsionar o seu negócio!
        </p>
        
        <a
          href="https://wa.me/551231990322" // Substitua pelo número real do WhatsApp
          className="btn btn-success btn-lg d-inline-flex align-items-center gap-2 shadow"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp className="fs-3" />
          Fale Conosco pelo WhatsApp
        </a>
      </div>
    </section>
  );
};

export default Contact;
